import React, { useEffect } from "react";
import PropTypes from "prop-types";

interface IPageProps {
  title: string;
  component: React.ComponentType<Record<string, unknown>>;
  [key: string]: unknown;
}

const Page: React.FC<IPageProps> = ({ title, component: Component, ...rest }) => {
  useEffect(() => {
    document.title = "Softion Software Solutions - " + title;
  }, [title]);

  return <Component {...rest} />;
};

Page.propTypes = {
  title: PropTypes.string.isRequired,
  component: PropTypes.elementType.isRequired,
};

export default Page;
